export default {"src":"/_next/static/media/filter_regular.0770aa4b.svg","height":24,"width":24};